import React, { useState } from 'react';
import { PageHeader } from '../../components/layout/PageHeader';
import { KPICard } from '../../components/ui/KPICard';
import { Card } from '../../components/ui/Card';
import { DataTable } from '../../components/ui/DataTable';
import { Tabs } from '../../components/ui/Tabs';
import { Button } from '../../components/ui/Button';
import { StatusPill } from '../../components/ui/StatusPill';
import { Badge } from '../../components/ui/Badge';
import { ClipboardListIcon, AlertCircleIcon, CheckCircleIcon, ClockIcon } from 'lucide-react';
const incidents = [{
  id: 'QI-2026-003',
  supplier: 'Oceanic Harvest Pte Ltd',
  severity: 'Major',
  category: 'Logistics',
  age: '4 days',
  status: 'Pending Supplier'
}, {
  id: 'QI-2026-004',
  supplier: 'CleanPro Services',
  severity: 'Minor',
  category: 'Service Quality',
  age: '1 day',
  status: 'Open'
}, {
  id: 'QI-2026-002',
  supplier: 'NutriPack Solutions',
  severity: 'Critical',
  category: 'Food Safety',
  age: '10 days',
  status: 'Pending Review'
}];
export const QualityConsolePage: React.FC = () => {
  const [activeTab, setActiveTab] = useState('all');
  return <div className="max-w-7xl mx-auto space-y-6" data-id="element-494">
      <PageHeader title="Quality Console" description="Track supplier quality incidents and corrective actions." primaryAction={<Button data-id="element-496">Log Incident</Button>} data-id="element-495" />

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-497">
        <KPICard title="Open Incidents" value="4" icon={<ClipboardListIcon className="w-5 h-5" data-id="element-499" />} data-id="element-498" />
        <KPICard title="Critical Severity" value="1" icon={<AlertCircleIcon className="w-5 h-5 text-status-error" data-id="element-501" />} data-id="element-500" />
        <KPICard title="Avg Resolution Days" value="14" icon={<ClockIcon className="w-5 h-5" data-id="element-503" />} data-id="element-502" />
        <KPICard title="Closure Rate" value="87%" icon={<CheckCircleIcon className="w-5 h-5 text-status-success" data-id="element-505" />} data-id="element-504" />
      </div>

      <Card noPadding data-id="element-506">
        <div className="px-6 pt-4 border-b border-border-light" data-id="element-507">
          <Tabs tabs={[{
          id: 'all',
          label: 'All Incidents'
        }, {
          id: 'open',
          label: 'Open'
        }, {
          id: 'supplier',
          label: 'Pending Supplier'
        }, {
          id: 'review',
          label: 'Pending Review'
        }]} activeTab={activeTab} onChange={setActiveTab} data-id="element-508" />
        </div>
        <div className="p-6" data-id="element-509">
          <DataTable data={incidents} columns={[{
          header: 'Case ID',
          accessorKey: 'id',
          cell: row => <span className="font-medium text-fpg-navy" data-id="element-511">{row.id}</span>
        }, {
          header: 'Supplier',
          accessorKey: 'supplier'
        }, {
          header: 'Severity',
          cell: row => <Badge variant={row.severity === 'Critical' ? 'error' : row.severity === 'Major' ? 'warning' : 'info'} data-id="element-512">
                    {row.severity}
                  </Badge>
        }, {
          header: 'Category',
          accessorKey: 'category'
        }, {
          header: 'Age',
          accessorKey: 'age'
        }, {
          header: 'Status',
          cell: row => <StatusPill status={row.status} data-id="element-513" />
        }]} data-id="element-510" />
        </div>
      </Card>
    </div>;
};